<script lang="ts">
    import type { UserMessagesCarrier } from "@app/models/api";
    import { delayPromise } from "@app/services/delay-promise";
    import { getUserMesages } from "@app/services/glosbe-dictionary-api/get-messages";
    import LoadingInProgress from "../LoadingInProgress.svelte";
    import NotificationsControllerSingleMessage from "./NotificationsControllerSingleMessage.svelte";

    let messagesPromise: Promise<UserMessagesCarrier> = undefined;
    function loadPage(page: number) {
        messagesPromise = delayPromise(getUserMesages(page), 500);
    }
    loadPage(0);
</script>

{#await messagesPromise}
    <LoadingInProgress />
{:then messages}
    <div class="m-auto max-w-80ch">
        {#each messages.messages as message, index}
            <NotificationsControllerSingleMessage {message} isFirst={index === 0}/>
        {/each}
    </div>
    <div class="py-2 text-center">
        {#if messages.page > 1}
            <button
                class="button-xs"
                on:click={() => loadPage(messages.page - 1)}>&laquo;</button
            >
        {/if}
        <div class="px-1 inline-block" />
        {#if messages.page < messages.pages}
            <button
                class="button-xs"
                on:click={() => loadPage(messages.page + 1)}>&raquo;</button
            >
        {/if}
    </div>
{/await}

<style>
    .max-w-80ch {
        max-width: 80ch;
    }
</style>
